import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TimeScheduleSlotEditComponent } from '../time-schedule-slot-edit/time-schedule-slot-edit.component'
import { TimeSchedule } from '../work-schedule'

export class IScheduleTimeSlotDialogOptions {
  readonly slot: TimeSchedule
}

@Component({
  selector: 'app-time-schedule-slot-dialog',
  templateUrl: './time-schedule-slot-dialog.component.html',
  styleUrls: ['./time-schedule-slot-dialog.component.scss'],
  imports: [TimeScheduleSlotEditComponent],
})
export class TimeScheduleSlotDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly original: TimeSchedule
  public readonly copy: TimeSchedule
  private dialogRef = inject<MatDialogRef<TimeScheduleSlotDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IScheduleTimeSlotDialogOptions>(MAT_DIALOG_DATA)
    this.copy = this.copySlot(data.slot)
    this.original = data.slot
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close(this.copySlot(this.original))
  }

  public onSave($event: Event): void {
    this.updateSlot(this.original, this.copy)
    this.close(this.copySlot(this.original))
  }

  public onDelete($event: Event): void {
    this.original.performance = 0
    this.close(this.copySlot(this.original))
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private close(slot?: TimeSchedule): void {
    this.dialogRef.close(slot)
  }

  private copySlot(slot: TimeSchedule): TimeSchedule {
    return new TimeSchedule(slot.start, slot.end, slot.performance)
  }

  private updateSlot(slotToUpdate: TimeSchedule, source: TimeSchedule): void {
    slotToUpdate.start = source.start
    slotToUpdate.end = source.end
    slotToUpdate.performance = source.performance
  }
}
